let ctx: CanvasRenderingContext2D;

/**
 * è·å canvas context
 */
export function getCanvasContext() {
  if (!ctx) {
    ctx = document.createElement('canvas').getContext('2d');
  }

  return ctx;
}
